import React, { PropTypes, Component } from "react";
import { NitroContentNotAvailable, NitroLoading } from "nitro-components";

import CardMetricLease from "./CardMetricLease";
import CardMetricUtilisation from "./CardMetricUtilisation";
import CardMetricVehicle from "./CardMetricVehicle";
import CardMetricDriver from "./CardMetricDriver";
import CardWithHeader from "../CardWithHeader";

import ButtonIcognito from "../../../../components/common/ButtonIcognito";

import {
  CARD_METRIC_LEASE,
  CARD_METRIC_UTILISATION,
  CARD_METRIC_VEHICLE,
  CARD_METRIC_DRIVER
} from "../../content";

import DashboardApi from "../../../../api/DashboardApi";
import {
  DRIVER_DASHBOARD_VEHICLE_SUMMARY,
  VEHICLE_DASHBOARD_DRIVER_SUMMARY
} from "../../../../api/const";

class ProfileDetailedView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading: false
    };
  }

  componentWillMount() {
    const { Id, Url, countryCode, companyCode, driverId, leaseId } = this.props;
    this.loadData(Id, Url, countryCode, companyCode, driverId, leaseId);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.leaseId !== this.props.leaseId) {
      this.loadData(
        nextProps.Id,
        nextProps.Url,
        nextProps.countryCode,
        nextProps.companyCode,
        nextProps.driverId,
        nextProps.leaseId
      );
    }
  }

  loadData = (id, url, countryCode, companyCode, driverId, leaseId) => {
    this.setState({
      loading: true
    });

    if (!(id && url && countryCode && companyCode && driverId && leaseId))
      return;

    // Check which api to use
    let API = DashboardApi.getCardSummary;
    if (DRIVER_DASHBOARD_VEHICLE_SUMMARY.indexOf(url) > -1) {
      API = DashboardApi.getVehicleSummary;
    } else if (VEHICLE_DASHBOARD_DRIVER_SUMMARY.indexOf(url) > -1) {
      API = DashboardApi.getDriverSummary;
    }

    API({
      id,
      countryCode: countryCode,
      companyCode: companyCode,
      driverId: driverId,
      leaseId: leaseId
    })
      .then(res => {
        if (res.success) {
          // Check if still mounted
          if (!this.mounted) {
            return;
          }

          this.setState({
            data: res.data.Data,
            loading: false,
            displayType: res.data.DisplayType
          });
        } else {
          throw new Error("DashboardApi.getTileData error");
        }
      })
      .catch(error => {
        if (!this.mounted) {
          return;
        }
        this.setState({
          data: null,
          loading: false
        });
        console.log("DashboardApi.getTileData error", error);
      });
  };

  onClick = () => {
    if (typeof this.props.onCardClick === "function") {
      this.props.onCardClick({ id: this.props.Id });
    }
  };

  renderConent() {
    if (this.state.loading) {
      return <NitroLoading center />;
    }

    let Component;
    let componentProps = {
      ...this.props,
      ...this.state.data
    };

    switch (this.state.displayType) {
      case CARD_METRIC_LEASE:
        Component = CardMetricLease;
        break;
      case CARD_METRIC_UTILISATION:
        Component = CardMetricUtilisation;
        break;
      case CARD_METRIC_VEHICLE:
        Component = CardMetricVehicle;
        componentProps.ImageKey = this.props.leaseData.ImageKey;
        componentProps.MakeModel = this.props.leaseData.MakeModel;
       // componentProps.MakeName = this.props.leaseData.MakeName;
       // componentProps.ModelName = this.props.leaseData.ModelName;
        break;

      case CARD_METRIC_DRIVER:
        Component = CardMetricDriver;
        componentProps.driverName = this.props.leaseData.driverName;
        break;

      default:
    }

    if (Component && this.state.data) {
      if (
        this.state.displayType === CARD_METRIC_VEHICLE ||
        this.state.displayType === CARD_METRIC_DRIVER
      ) {
        return <Component {...componentProps} />;
      }

      return (
        <ButtonIcognito fullWidth onClick={this.onClick}>
          <Component {...componentProps} />
        </ButtonIcognito>
      );
    }

    return (
      <NitroContentNotAvailable imageHeight="60px" imageMarginTop="50px" />
    );
  }

  render() {
    // TODO: Put in link to vehicle dashboard
    const headerRight = this.state.data
      ? {
          label: this.state.data.Text,
          action: "",
          icon: this.state.data.Icon,
          iconPosition: "left"
        }
      : null;

    if (this.state.data && (this.state.displayType === "cardMetricVehicle" || this.state.displayType === "cardMetricDriver")) {
      headerRight.action = this.props.showHistoryDetails;
    }

    return (
      <CardWithHeader
        key={`card-${this.props.Id}`}
        grid="3"
        panelHeight="280px"
        transition
        transitionDelay={100 * this.props.index}
        transitionDuration={800}
        headerLeft={this.props.Title}
        headerRight={headerRight}
      >
        {this.renderConent()}
      </CardWithHeader>
    );
  }
}

ProfileDetailedView.propTypes = {
  reportUrl: PropTypes.string,
  reportId: PropTypes.string,
  companyCode: PropTypes.string,
  countryCode: PropTypes.string,
  driverId: PropTypes.string,
  index: PropTypes.number,
  onCardClick: PropTypes.func,
  type: PropTypes.string,
  leaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  leaseData: PropTypes.object,
  Title: PropTypes.string,
  Id: PropTypes.string,
  showHistoryDetails: PropTypes.func,
  Url: PropTypes.string
};

export default ProfileDetailedView;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/ProfileDetailedView.js